var exports = {
  "Q": "PendingFriendsView.module__pendingViewContainer___Z0tXdE",
  "X": "PendingFriendsView.module__scroller___Z0tXdE",
};

module.exports = exports;
